import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { routes } from "./Router";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
const App = () => {
  return (
    <Routes>
      {routes.map((route, count) => {
        return (
          <Route
            key={count}
            path={route.path}
            element={
              <route.layout>
                <route.component />
              </route.layout>
            }
          />
        );
      })}
    </Routes>
  );
};
export const WebApp = () => {
  return (
    <Routes>
      {routes.map((route, count) => {
        return (
          <Route
            key={count}
            path={route.path}
            element={
              <route.layout>
                <route.component />
              </route.layout>
            }
          />
        );
      })}
    </Routes>
  );
};
export default App;
